import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import TextInput from "../../components/TextInput/TextInput";
import PropTypes from "prop-types";
import MemberUserController from "./Controller/member_user_controller.ts";
import { notification, Alert } from "antd";
import { useSearchParams } from "react-router-dom";
import PasswordInput from "../../components/TextInput/PasswordInput.js";

// import InfinityEncryptor from "../../components/EncryptDecrypt/InfinityEncryptor.js";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const Dashboard = () => {
  // notification
  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, desc, msg) => {
    api[type]({
      message: msg,
      description: desc,
    });
  };

  const [searchParams] = useSearchParams();
  const userID = searchParams.get("userID");
  const [name, setName] = useState();

  useEffect(() => {
    if (userID) {
      const payload = new FormData();
      payload.append("userID", userID);
      MemberUserController.getUserInfo(payload).then((response) => {
        console.log(response);
        setName(response.name);
      });
    }
  }, [userID]);
  const {
    handleSubmit,
    register,
    getValues,
    formState: { errors },
    control,
    reset,
  } = useForm({
    defaultValues: {
      newPassword: "",
      confirmNewPassword: "",
      sixDigitPIN: "",
    },
  });

  const [passwordError, setPasswordError] = useState("");
  const [alertVisible, setAlertVisible] = useState(false);

  const onSubmit = async (data) => {
    if (data.confirmNewPassword !== data.newPassword) {
      setAlertVisible(true);
    } else {
      setAlertVisible(false);
      const payload = {
        ID: userID,
        data: data,
      };
      if (Object.keys(errors).length > 0) {
        console.log("Form has errors:", errors);
        return; // Prevent submission if there are errors
      }

      try {
        const response = await MemberUserController.resetPassword(payload);
        if (response?.status === "success") {
          openNotificationWithIcon(
            "success",
            "Your data has been saved successfully!",
            "Success"
          );
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
  };

  const onInvalid = (errors) => {
    console.log("Form has errors:", errors);
  };

  const handleClose = () => {
    setAlertVisible(false);
  };

  const handlePasswordError = (errorMessage) => {
    setPasswordError(errorMessage); // Update the error state
    setAlertVisible(true); // Show the alert when there's an error
  };
  useEffect(() => {
    if (alertVisible) {
      const timer = setTimeout(() => {
        setAlertVisible(false);
      }, 5000); // Disappear after 3 seconds

      return () => clearTimeout(timer); // Cleanup timer
    }
  }, [alertVisible]);

  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: "#e8e8e8",
        height: "100%",
        minHeight: "100vh",
        width: "100vw",
      }}
    >
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
        }}
      >
        <DrawerHeader />
        {contextHolder}

        {alertVisible && (
          <Alert
            type={
              passwordError === "Passwords match!" ||
              passwordError === "Looks good!"
                ? "success"
                : "error"
            }
            message={passwordError}
            closable
            onClose={handleClose}
            showIcon
          />
        )}

        <form
          onSubmit={handleSubmit(onSubmit, onInvalid, {
            shouldFocusError: true,
          })}
        >
          <Typography variant="h4" sx={{ fontWeight: "bold" }}>
            Change Password
          </Typography>

          <Grid container spacing={2} sx={{ p: 2 }}>
            <Grid size={4}>
              <Typography variant="h6">Name</Typography>
            </Grid>
            <Grid size={8}>
              <Typography variant="h6">{name}</Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} sx={{ p: 2 }}>
            <Grid size={4}>
              <Typography variant="h6">New Password</Typography>
            </Grid>
            <Grid size={8}>
              <PasswordInput
                type="text"
                {...register("newPassword", {
                  required: "This field is required",
                })}
                onErrorCheck={handlePasswordError} // Pass the error handler function
                control={control}
                getValues={getValues} // Pass getValues as a prop
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ p: 2 }}>
            <Grid size={4}>
              <Typography variant="h6">Confirm New Passsword</Typography>
            </Grid>
            <Grid size={8}>
              <PasswordInput
                type="text"
                {...register("confirmNewPassword", {
                  required: "This field is required",
                })}
                onErrorCheck={handlePasswordError}
                control={control}
                getValues={getValues} // Pass getValues as a prop
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ p: 2 }}>
            <Grid size={4}>
              <Typography variant="h6">6-digit PIN</Typography>
            </Grid>
            <Grid size={8}>
              <TextInput
                type="number"
                {...register("sixDigitPIN", {
                  required: "This field is required",
                })}
                onErrorCheck={errors ? "" : ""}
                control={control}
              />
            </Grid>
          </Grid>

          <Button
            sx={{
              backgroundColor: "#d33333",
            }}
            variant="contained"
            type="submit"
          >
            <Typography variant="h6">Save</Typography>
          </Button>
        </form>
      </Box>
    </Box>
  );
};

export default Dashboard;
